import axios from "./axios.js"

// const token = "1|ku7lIj2vaSsk0iYkGbytMxN5FCu6sdojX6fM2fG0";


export class AllCityMaster {

    static getCities() {
        return axios.get("/allcity");

    }
    static citySearch(query) {
        return axios.post('allcitysearch', query)
    }
    static cityIdsToName(query) {
        return axios.post('allcityids', query)
    }
    static getCityData(stateId) {
        let defaultURL = `/allcitydata/${stateId}`;
        return axios.get(defaultURL);
    }
    static getCity(cityId) {
        let defaultURL = `/allcity/${cityId}`;
        return axios.get(defaultURL);
    }
    static createCity(city) {
        let defaultURL = `/allcity`;
        // return axios.post(defaultURL,city);
        try {
            return axios.post(defaultURL, city);
        } catch (error) {
            console.log("this is error ", error)
            if (error.response.status === 422) {
                return error.response.data.errors

            }
            // console.log(errors.value.name);
        }
    }
    static updateCity(city, cityId) {
        let defaultURL = `/allcity/${cityId}`;
        return axios.put(defaultURL, city);
    }
    static deleteCity(cityId) {
        let defaultURL = `/allcity/${cityId}`;
        return axios.delete(defaultURL);
    }

}